import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { EditorEligibilityTreeStore } from '../editor-eligibility-tree/editor-eligibility-tree.store';
import { EditorEligibility } from '../editor-eligibility/editor-eligibility.model';
import { EditorEligibilityDialogDeleteComponent } from '../editor-eligibility-dialog-delete/editor-eligibility-dialog-delete.component';


@Component({
    selector: 'eas-editor-eligibility-dialog',
    templateUrl: './editor-eligibility-dialog.component.html',
    styleUrls: ['./editor-eligibility-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityDialogComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  dialogTitle = $localize `Eligibility editor`;
  assignedBookingItemNameList: string[];

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<EditorEligibilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      action: 'create'|'edit'|'duplicate',
      eligibility: EditorEligibility,
      assignedBookingItemNameList: string[]
    },
    private eligibilityTreeStore: EditorEligibilityTreeStore
  ) {

  }

  ngOnInit() {
    switch (this.data.action) {
      case 'create':
        this.dialogTitle = $localize `Create a new eligibility rule set`;
        this.eligibilityTreeStore.initializeEmpty();
        break;
      case 'edit':
        this.dialogTitle = $localize `Edit the eligibility rule set`;
        this.eligibilityTreeStore.initializeFromEligibility(this.data.eligibility);
        break;
      case 'duplicate':
        this.dialogTitle = $localize `Edit the copy of the eligibility rule set`;
        this.eligibilityTreeStore.initializeFromDuplicatingEligibility(this.data.eligibility);
        break;
    }

    this.assignedBookingItemNameList = this.data.assignedBookingItemNameList;
  }

  ngOnDestroy() {
    this.eligibilityTreeStore.terminate();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    this.dialogRef.close({
      action: this.data.action === 'edit' ? 'edit' : 'create',
      eligibility: this.eligibilityTreeStore.getEligibility()
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onDelete() {
    const deleteDialogRef = this.dialog.open(EditorEligibilityDialogDeleteComponent, {
      maxWidth: '400px'
    });

    deleteDialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.dialogRef.close({
          action: 'delete',
          eligibility: undefined
        });
      }
    });
  }
}
